import React from 'react';
import PropTypes from 'prop-types';
import DivLayoutV2Card from './DivLayoutV2Card';
import './DivLayoutV2.css';

const DivLayoutV2TimelineItem = ({
  badge,
  headerRight,
  fields,
  children,
  isLast,
  dotColor = '#6030be',
}) => (
  <div className={`timeline-item-simple${isLast ? ' last' : ''}`}>
    <div className="timeline-dot-simple" style={{ color: dotColor }} />
    <DivLayoutV2Card badge={badge} headerRight={headerRight} fields={fields}>
      {children}
    </DivLayoutV2Card>
  </div>
);

DivLayoutV2TimelineItem.propTypes = {
  badge: PropTypes.string,
  headerRight: PropTypes.string,
  fields: PropTypes.array,
  children: PropTypes.node,
  isLast: PropTypes.bool,
  dotColor: PropTypes.string,
};

export default DivLayoutV2TimelineItem;
